import { render, staticRenderFns } from "./DpChnnlDetail.vue?vue&type=template&id=2749b02b&scoped=true"
import script from "./DpChnnlDetail.vue?vue&type=script&lang=js"
export * from "./DpChnnlDetail.vue?vue&type=script&lang=js"
import style0 from "./DpChnnlDetail.vue?vue&type=style&index=0&id=2749b02b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2749b02b",
  null
  
)

export default component.exports